import { ReactNode } from 'react';

import clsx from 'clsx';

import Close from '@popup/components/Close';

export interface PopupWrapperProps {
  children?: ReactNode;
  className?: string;
  handleClick?: () => void;
  isMaxHeightLimit?: boolean;
  isMaxHeightMobileBigger?: boolean;
  isCloseButton?: boolean;
}

const PopupWrapper = ({
  children,
  className,
  handleClick,
  isMaxHeightLimit = false,
  isMaxHeightMobileBigger = false,
  isCloseButton = true,
}: PopupWrapperProps) => (
  <div
    className={clsx(
      'flex w-full flex-wrap overflow-y-auto md:mt-0 md:w-auto',
      isMaxHeightLimit ? 'md:max-h-[340px]' : 'md:max-h-full',
      isMaxHeightMobileBigger ? 'max-h-[440px]' : 'max-h-[200px]',
      isCloseButton && 'mt-[72px]',
      className,
    )}
  >
    {isCloseButton && <Close className="md:hidden" onClick={handleClick} />}
    {children}
  </div>
);

export default PopupWrapper;
